module.exports = __webpack_public_path__ + "img/rank3.5639dc51.png";